<template>
  <v-tabs fixed-tabs :v-once="query">
    <v-tab ripple>
      Workflow
    </v-tab>
    <v-tab ripple>
      Status History
    </v-tab>
    <v-tab ripple>
      Modified History
    </v-tab>
    <v-tab-item>
      <v-stepper :value="steps" vertical class="policyLifeCycle" v-if="loadNormalWorkFlow">
        <v-stepper-step step="1" v-bind:complete="steps > 1">
          <span>Sales Opportunity</span>
          <span v-if="!query">
            <v-btn flat icon color="primary" @click="$emit('salesOpportunity')">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </span>
        </v-stepper-step>
        <v-stepper-content step="1">
          <div v-if="steps > 1">
            <div v-if="showProspect">
              <v-subheader>Requested By:</v-subheader>
              <div v-if="this.quotation.commonForm.salesOppName">
                <v-icon>mdi-comment-account</v-icon>
                <span>{{quotation.commonForm.salesOppName}}</span>
              </div>
              <div v-if="this.quotation.commonForm.salesOppPhone">
                <v-icon>mdi-phone</v-icon>
                <span>{{quotation.commonForm.salesOppPhone}}</span>
              </div>
              <div v-if="this.quotation.commonForm.salesOppEmail">
                <v-icon>mdi-email</v-icon>
                <span>{{quotation.commonForm.salesOppEmail}}</span>
              </div>
            </div>
          </div>
        </v-stepper-content>
        <v-stepper-step step="2" v-bind:complete="steps > 2">
          {{quoteStatusConst.NQ}}
        </v-stepper-step>
        <v-stepper-content step="2">
          <div v-if="steps >= 2">
            <template v-if="nqDetails">
              <v-subheader>Created By:</v-subheader>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{nqDetails.name}}</span>
              </div>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{formatDateTime(nqDetails.statusDate)}}</span>
              </div>
            </template>
            <div>
              <v-icon>mdi-domain</v-icon>
              <span>{{intermediary}}</span>
            </div>
          </div>
        </v-stepper-content>
        <v-stepper-step step="3" v-bind:complete="steps > 3">
          {{quoteStatusConst.IF}} <span v-if="quotation.commonInfo.paid"> - Paid</span>
        </v-stepper-step>
        <v-stepper-content step="3">
          <div v-if="steps >= 3">
            <template v-if="ifDetails">
              <v-subheader>Approved By:</v-subheader>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{ifDetails.name}}</span>
              </div>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{formatDateTime(ifDetails.statusDate)}}</span>
              </div>
            </template>
          </div>
        </v-stepper-content>
        <v-stepper-step step="4" v-bind:complete="steps > 4">
          {{quoteStatusConst.PO}}
        </v-stepper-step>
        <v-stepper-content step="4">
          <div v-if="steps >= 4">
            <template v-if="poDetails">
              <v-subheader>Posted By:</v-subheader>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{poDetails.name}}</span>
              </div>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{formatDateTime(poDetails.statusDate)}}</span>
              </div>
              <div>
                <v-icon title="Policy No">mdi-key</v-icon>
                <span>{{$store.state.agency.quotation.commonInfo.polNo}}</span>
              </div>
            </template>
          </div>
        </v-stepper-content>
      </v-stepper>
      <v-stepper :value="steps" vertical class="policyLifeCycle" v-else>
        <v-stepper-step step="1" v-bind:complete="true">
          <span>{{currentStatusLabel}}</span>
        </v-stepper-step>
        <v-stepper-content step="1">
          <template v-if="currentStatus === 'VO' && voDetails">
            <v-subheader>Void By:</v-subheader>
            <div>
              <v-icon>mdi-account-edit</v-icon>
              <span>{{voDetails.name}}</span>
            </div>
            <div>
              <v-icon>mdi-calendar-clock</v-icon>
              <span>{{formatDateTime(voDetails.statusDate)}}</span>
            </div>
          </template>
          <template v-else-if="currentStatus === 'NTU' && ntuDetails">
            <v-subheader>Status Change By:</v-subheader>
            <div>
              <v-icon>mdi-account-edit</v-icon>
              <span>{{ntuDetails.name}}</span>
            </div>
            <div>
              <v-icon>mdi-calendar-clock</v-icon>
              <span>{{formatDateTime(ntuDetails.statusDate)}}</span>
            </div>
          </template>
          <template v-else-if="currentStatus === 'CL' && clDetails">
            <v-subheader>Cancelled By:</v-subheader>
            <div>
              <v-icon>mdi-account-edit</v-icon>
              <span>{{clDetails.name}}</span>
            </div>
            <div>
              <v-icon>mdi-calendar-clock</v-icon>
              <span>{{formatDateTime(clDetails.statusDate)}}</span>
            </div>
          </template>
          <template v-else-if="currentStatus === 'DC' && dcDetails">
            <v-subheader>Declined By:</v-subheader>
            <div>
              <v-icon>mdi-account-edit</v-icon>
              <span>{{dcDetails.name}}</span>
            </div>
            <div>
              <v-icon>mdi-calendar-clock</v-icon>
              <span>{{formatDateTime(dcDetails.statusDate)}}</span>
            </div>
          </template>
        </v-stepper-content>
      </v-stepper>
    </v-tab-item>
    <v-tab-item>
      <status-history></status-history>
    </v-tab-item>
    <v-tab-item>
      <audit-history></audit-history>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { formatDisplayDateTime } from '@/utils/date'
import { quoteStatus } from '@/const/underwriting'
import StatusHistory from '../../shared/StatusHistory'
import AuditHistory from '../../shared/AuditHistory'

export default {
  computed: {
    currentStatus() {
      return this.$store.state.agency.quotation.commonInfo.statusCode
    },
    steps() {
      // Travel Policy Life Cycle is as such:
      /*
        1: Sales Opportunity / Extra statuses (VO/NTU/CL)
        2: NQ: Quotation
        3: IF: In-Force
        4: PO: Policy
      */
      let lifeCycle = 1
      if (this.currentStatus === 'NQ') {
        lifeCycle = 2
      } else if (this.currentStatus === 'IF') {
        lifeCycle = 3
      } else if (this.currentStatus === 'PO') {
        lifeCycle = 4
      } else {
        lifeCycle = 1
      }

      return lifeCycle
    },
    quotation() {
      return this.$store.state.agency.quotation
    },
    showProspect() {
      if (this.quotation.commonForm.salesOppName || this.quotation.commonForm.salesOppEmail || this.quotation.commonForm.salesOppPhone) {
        return true
      } else {
        return false
      }
    },
    intermediary() {
      // return extractLabel(this.$store.state.agency.quotationSettings.intermediaries, this.quotation.commonForm.intermediary)
      return this.quotation.commonForm.intermediary + ' - ' + this.quotation.queryInfo.intermediary
    },
    quoteStatusConst() {
      return quoteStatus
    },
    loadNormalWorkFlow() {
      // Steps will only be 1 if its Sales Opp or other statuses
      // Once reach this stage, it shouldn't be sales opp anymore
      if (this.steps === 1) {
        return false
      } else {
        return true
      }
    },
    currentStatusLabel() {
      if (quoteStatus[this.currentStatus]) {
        return quoteStatus[this.currentStatus]
      } else {
        return 'Unknown Status'
      }
    },

    nqDetails() {
      return this.getQuoteStatusDetail('NQ')
    },
    ifDetails() {
      return this.getQuoteStatusDetail('IF')
    },
    poDetails() {
      return this.getQuoteStatusDetail('PO')
    },
    voDetails() {
      return this.getQuoteStatusDetail('VO')
    },
    ntuDetails() {
      return this.getQuoteStatusDetail('NTU')
    },
    clDetails() {
      return this.getQuoteStatusDetail('CL')
    },
    dcDetails() {
      return this.getQuoteStatusDetail('DC')
    }
  },
  methods: {
    formatDateTime(date) {
      return formatDisplayDateTime(date)
    },
    getQuoteStatusDetail(statusCode) {
      return this.$store.getters.getQuoteStatusDetail(statusCode)
    }
  },
  components: {
    StatusHistory,
    AuditHistory
  },
  props: {
    query: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
// Will inherit the css from LifeCycle (as this is the child component)
</style>
